module.exports = __webpack_public_path__ + "img/colonial.340cb7fd.png";